import { z } from "zod";

/**
 * URL search-params schema for `/settings/hr`. Empty: `calendarId` was
 * FND-015's task 1 addition, an optional deep link into one holiday
 * calendar. FND-015b task 2 moved the whole holiday calendars section (and
 * `calendarId` with it) onto `attendance-settings.route.search.ts`, since
 * calendars are now managed on `/settings/attendance`'s Calendars tab, not
 * here. This page keeps no search params of its own today.
 *
 * Still wired to `validateSearch` in router.tsx (see the comment there):
 * kept ahead of need so a future param only has to change this one file.
 */
export const hrSettingsSearchSchema = z.object({}).strict();

export type HrSettingsSearch = z.infer<typeof hrSettingsSearchSchema>;
